import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
  AfterViewInit,
  OnChanges,
} from '@angular/core';
import { AnimationController } from '@ionic/angular';

enum SegmentState {
  'week' = 'week',
  'month' = 'month',
}

/**
 * Card showing total bill due in total.
 */
@Component({
  selector: 'app-bills-due-card',
  styleUrls: ['./bills-due-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ion-card>
      <ion-card-content>
        <div class="main-wrapper">
          <ion-item lines="none" class="due-item ion-no-padding">
            <div slot="start">
              <ion-label class="header">Bills due</ion-label>
            </div>
            <div slot="end" class="segment">
              <ion-button mode="ios" size="small" color="primary" [fill]="selected =='week'?'solid':'outline'" (click)="buttonClicked(SegmentState.week)">Week</ion-button>
              <ion-button mode="ios" size="small" color="primary" [fill]="selected =='month'?'solid':'outline'"(click)="buttonClicked(SegmentState.month)">Month</ion-button>
              </div>
          </ion-item>

          <div class="amount ob-slides" #obSlides>
            <div class="ob-slides-inner">
              <ion-label #weekRef class="week">
                <div>{{ getWeeklyTotalAmount() | currency }}</div>
                <span
                  class="including-overdue"
                  *ngIf="totalOverdueAmount && totalOverdueAmount > 0"
                >
                  (including <span class="amount">{{ totalOverdueAmount | currency }}</span> overdue)
                </span>
              </ion-label>
              <ion-label #monthRef class="month">
                <div>
                  {{ getMonthlyTotalAmount() | currency }}
                </div>
                <span
                  class="including-overdue"
                  *ngIf="totalOverdueAmount && totalOverdueAmount > 0"
                >
                  (including <span class="amount">{{ totalOverdueAmount | currency }}</span> overdue)
                </span>
              </ion-label>
            </div>
          </div>
        </div>
        
      </ion-card-content>
    </ion-card>
  `,
})
export class BillsDueCardComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('obSlides', { read: ElementRef }) obSlidesRef: ElementRef;
  @Input() weeklyDueAmount: number;
  @Input() monthlyDueAmount: number;
  @Input() totalOverdueAmount: number;
  @Output() viewAllBillsClick = new EventEmitter<boolean>();
  public selected: SegmentState = SegmentState.week;
  SegmentState = SegmentState;
  public prevSelected: SegmentState = SegmentState.week;
  constructor(private animationCtrl: AnimationController, private elRef: ElementRef) {}
  ngOnInit() {
  }
  ngAfterViewInit() {
    // this.updateAmountBlockHeight();
  }
  ngOnChanges() {
    // this.updateAmountBlockHeight();
  }
  updateAmountBlockHeight() {
    if (this.totalOverdueAmount && this.totalOverdueAmount > 0) {
      const el = this.elRef.nativeElement as HTMLElement;
      const newValue = '84px';
      const value = el.style.getPropertyValue('--bills-amount-block-height');
      if (value !== newValue) {
        el.style.setProperty('--bills-amount-block-height', '84px');
      }
    }
  }
  onViewAllBillsClick() {
    this.viewAllBillsClick.emit(true);
  }
  segmentChanged(ev: any) {
    this.triggerObSlidesAnimation(this.selected, this.prevSelected);
    this.prevSelected = ev.detail.value;
  }
  buttonClicked(name:SegmentState) {
    this.selected = name;
    this.triggerObSlidesAnimation(this.selected, this.prevSelected);
    this.prevSelected = name;
  }
  triggerObSlidesAnimation(newSelected: SegmentState, prevSelected: SegmentState) {
    const obSlidesEl = this.obSlidesRef.nativeElement as HTMLElement;
    const animation = this.animationCtrl
      .create()
      .addElement(obSlidesEl.querySelector('.ob-slides-inner'))
      .duration(200);
    const childs = obSlidesEl.querySelectorAll('.ob-slides-inner *');
    const oldValIndex = Object.keys(SegmentState).indexOf(prevSelected);
    const newValIndex = Object.keys(SegmentState).indexOf(newSelected);
    if (childs?.length <= 1 || oldValIndex === newValIndex) return;

    animation.fromTo(
      'transform',
      `translateX(${oldValIndex * -100}%)`,
      `translateX(${newValIndex * -100}%)`,
    );
    animation.play();
  }
  getWeeklyTotalAmount() {
    return this.weeklyDueAmount + this.totalOverdueAmount;
  }
  getMonthlyTotalAmount() {
    return this.monthlyDueAmount + this.totalOverdueAmount;
  }
}
